import React from "react";

/**
 * Surface — the single shared raised container for the dark theme (DESIGN.md §4).
 *
 * Every raised element (sidebar topic items, the reading card, right-panel
 * cards, the morphology modal) renders through this so the app stays unified.
 * The gradient/border live in theme.css `.surface`; this only composes state.
 *
 *   active      — selected state (brighter gold border + ring)
 *   interactive — hover brightens the border (use for clickable surfaces)
 *   nudge       — list-item hover slides 2px (only with interactive)
 *   as          — element/tag to render (default "div", e.g. "button", "li")
 */
export default function Surface({
  as: Tag = "div",
  active = false,
  interactive = false,
  nudge = false,
  glass = false,
  className = "",
  children,
  ...rest
}) {
  const cls = [
    glass ? "surface-glass" : "surface",
    interactive && "surface--interactive",
    interactive && nudge && "surface--nudge",
    active && "surface--active",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag className={cls} {...rest}>
      {children}
    </Tag>
  );
}
